import { Trans, useTranslation } from 'react-i18next';

import { ReactComponent as MaintenanceInProgress } from 'shared/assets/images/components/emptyState/maintenanceInProgress.svg';
import { InfoTemplate } from 'shared/components/InfoTemplate';

import type { FC } from 'react';

export const EMPTY_STATE_TEST_ID = 'error-state';

export const ErrorState: FC = () => {
  const { t } = useTranslation();

  return (
    <InfoTemplate
      data-testid={EMPTY_STATE_TEST_ID}
      size="md"
      header={t('GSP.pages.parentHelper.emptyState.header')}
      description={
        <Trans i18nKey="GSP.pages.parentHelper.emptyState.description" />
      }
      imageProps={{ width: 240, height: 240 }}
    >
      {/* TODO: add aria-label after an accessibility research */}
      {imageProps => <MaintenanceInProgress {...imageProps} />}
    </InfoTemplate>
  );
};
